/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { NoveltyCalcLaunchStatusFilter } from './NoveltyCalcLaunchStatusFilter';
import {
    NoveltyCalcLaunchStatusFilterFromJSON,
    NoveltyCalcLaunchStatusFilterFromJSONTyped,
    NoveltyCalcLaunchStatusFilterToJSON,
    NoveltyCalcLaunchStatusFilterToJSONTyped,
} from './NoveltyCalcLaunchStatusFilter';

/**
 * 
 * @export
 * @interface NoveltyCalcRequest
 */
export interface NoveltyCalcRequest {
    /**
     * 
     * @type {number}
     * @memberof NoveltyCalcRequest
     */
    planningYear: number;
    /**
     * 
     * @type {number}
     * @memberof NoveltyCalcRequest
     */
    priceUnitId: number;
    /**
     * 
     * @type {NoveltyCalcLaunchStatusFilter}
     * @memberof NoveltyCalcRequest
     */
    launchStatusFilter: NoveltyCalcLaunchStatusFilter;
    /**
     * 
     * @type {boolean}
     * @memberof NoveltyCalcRequest
     */
    overwritePreliminaryPrices: boolean;
    /**
     * 
     * @type {number}
     * @memberof NoveltyCalcRequest
     */
    lpIndexOverride?: number | null;
}



/**
 * Check if a given object implements the NoveltyCalcRequest interface.
 */
export function instanceOfNoveltyCalcRequest(value: object): value is NoveltyCalcRequest {
    if (!('planningYear' in value) || value['planningYear'] === undefined) return false;
    if (!('priceUnitId' in value) || value['priceUnitId'] === undefined) return false;
    if (!('launchStatusFilter' in value) || value['launchStatusFilter'] === undefined) return false;
    if (!('overwritePreliminaryPrices' in value) || value['overwritePreliminaryPrices'] === undefined) return false;
    return true;
}

export function NoveltyCalcRequestFromJSON(json: any): NoveltyCalcRequest {
    return NoveltyCalcRequestFromJSONTyped(json, false);
}

export function NoveltyCalcRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoveltyCalcRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'planningYear': json['planningYear'],
        'priceUnitId': json['priceUnitId'],
        'launchStatusFilter': NoveltyCalcLaunchStatusFilterFromJSON(json['launchStatusFilter']),
        'overwritePreliminaryPrices': json['overwritePreliminaryPrices'],
        'lpIndexOverride': json['lpIndexOverride'] == null ? undefined : json['lpIndexOverride'],
    };
}

export function NoveltyCalcRequestToJSON(json: any): NoveltyCalcRequest {
    return NoveltyCalcRequestToJSONTyped(json, false);
}

export function NoveltyCalcRequestToJSONTyped(value?: NoveltyCalcRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'planningYear': value['planningYear'],
        'priceUnitId': value['priceUnitId'],
        'launchStatusFilter': NoveltyCalcLaunchStatusFilterToJSON(value['launchStatusFilter']),
        'overwritePreliminaryPrices': value['overwritePreliminaryPrices'],
        'lpIndexOverride': value['lpIndexOverride'],
    };
}

